<template>
  <div class="ph-wrapper">
    <!-- <div class="btns">
            <div class="input-box">
                <input class="checkbox" type="checkbox" id="hideSymbol" v-model="hideOtherSymbol" />
                <label for="hideSymbol"></label>
                <span>Hide Other Symbols</span>
            </div>
        </div> -->
    <!-- <div class="gray-line"></div> -->
    <NodataView v-if="rows.length === 0" height="200px" />
    <div class="row-wrapper" v-for="row in rows" :key="row.ordid">
      <div class="symbol sub">
        <img class="coin-img" :src="getCoinIcon(row.symbol)" />
        <p>{{ row.symbol }}USDT</p>
        <span class="perp">Perp</span>
        <span :class="row.side === 'buy' ? 'bg-plus' : 'bg-minus'">
          {{ row.margin_type === "cross" ? "Cross" : "Isolated" }}
          {{ row.side === "buy" ? "Long" : "Short" }}
        </span>
        <span class="closed" v-if="!isMobile">{{
          $t("trading.table.closed")
        }}</span>
      </div>
      <div class="coin-info">
        <p>{{ $t("trading.table.cpnl") }}</p>
        <span
          :class="[
            'pnl',
            String(row.close_pnl)?.charAt(0) === '-' ? 'txt-minus' : 'txt-plus',
          ]"
        >
          {{ formatNumberWithComma(row.close_pnl) }} USDT
        </span>
      </div>
      <div class="coin-info">
        <p>{{ $t("trading.table.entryPrice") }}</p>
        <span>{{ formatNumberWithComma(row.entry_price) }} USDT</span>
      </div>
      <div class="coin-info">
        <p>{{ $t("trading.table.avgcp") }}</p>
        <span>{{ formatNumberWithComma(row.close_price) }} USDT</span>
      </div>
      <div class="coin-info">
        <p>{{ $t("trading.table.cv") }}</p>
        <span>{{ formatNumberWithComma(row.close_vol) }} USDT</span>
      </div>
      <div class="coin-info">
        <p>{{ $t("trading.table.closed") }}</p>
        <span>{{ row.close_datetime }}</span>
      </div>
      <div class="gray-line" v-if="!isMobile"></div>
    </div>
  </div>
</template>

<script setup>
import NodataView from "@/components/common/noData/NodataView.vue";
import dayjs from "dayjs";
import { formatNumberWithComma } from "@/utils/order";
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const isMobile = computed(() => store.state.account.isMobile);

// const hideOtherSymbol = computed({
//     get: () => store.state.user_history.hideOtherSymbol,
//     set: (value) => store.commit('user_history/setHideOtherSymbol', value)
// })

const rows = computed(() => {
  const { hideOtherSymbol, positionHistoryList: list } =
    store.state.user_history;
  const symbol = store.state.transact.ticker;
  const date = store.state.user_history.date;
  const filteredBySymbol = hideOtherSymbol
    ? list.filter((v) => v.symbol === symbol)
    : list;

  if (isMobile.value) return filteredBySymbol;

  const start = dayjs(date.start);
  const end = dayjs(date.end).endOf("day");
  return filteredBySymbol.filter((v) => {
    const dt = dayjs(v.close_datetime, "YYYY-MM-DD HH:mm:ss");
    return (
      (dt.isAfter(start) && dt.isBefore(end)) ||
      dt.isSame(start) ||
      dt.isSame(end)
    );
  });
});
const getCoinIcon = (symbol) => {
  try {
    return require(`@/assets/images/coin_logos/${symbol.toLowerCase()}.png`);
  } catch {
    return require("@/assets/images/coin_logos/default_dark.png");
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/scss/components/trading/history/openOrders.scss" as openOrders;
@use "@/assets/scss/components/trading/history/positionHistory.scss" as
  positionHistory;
</style>
